import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from 'environments/environment';

import { EntityDetailsService } from 'app/entities/details/entity-details.service';

import { ConstantsService } from 'app/services/constants-service';

import { EntityOtherService } from './entity-other.service';

@Component({
  selector: 'app-entity-other',
  templateUrl: './entity-other.component.html'
})

export class EntityOtherComponent {
  @ViewChild('iFrame') iFrame: ElementRef;

  gwtIFrameUrl: any;
  gwtCafUrl: any;
  gwtFinanceUrl: any;
  gwtRelationsUrl: any;
  gwtAuditUrl: any;
  gwtDocumentsUrl: any;
  gwtEmailsUrl: any;
  gwtResearchUrl: any;
  gwtMonitoringUrl: any;
  gwtTransactionProfileUrl: any;
  gwtTimeTrackingUrl: any;
  gwtSurveyhUrl: any;
  isPerson: boolean;
  gwtRelationShipDiagramUrl: any;

  constructor(public route: ActivatedRoute,
    public router: Router,
    public domSanitizer: DomSanitizer,
    public entityDetailsService: EntityDetailsService,
    public entityOtherService: EntityOtherService) {

    this.entityOtherService
      .onEntityIdChanged()
      .subscribe(entityIdDetails => {
        const type = entityIdDetails && entityIdDetails.entityType
          ? entityIdDetails.entityType.toString().toLowerCase()
          : '';
        this.isPerson = type === 'person';

        // Default iframe still expects the legacy underlying id (org/person id)
        const underlyingId = this.isPerson ? entityIdDetails.personId : entityIdDetails.orgId;
        const urlPrefix = this.isPerson ? ConstantsService.PERSON_DETAILS_PAGE : ConstantsService.ORG_DETAILS_PAGE;
        const urlSuffix = urlPrefix + ';id=' + underlyingId;
        const entityRedirectUrl = ConstantsService.APP_HOME_URL + urlSuffix;
        this.gwtIFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(entityRedirectUrl);

        this.gwtCafUrl = this.getComponentUrl('intro', entityIdDetails.entityId);
        this.gwtFinanceUrl = this.getComponentUrl('finance', entityIdDetails.entityId);
        this.gwtRelationsUrl = this.getComponentUrl('relations', entityIdDetails.entityId);
        this.gwtAuditUrl = this.getComponentUrl('audit', entityIdDetails.entityId);
        this.gwtDocumentsUrl = this.getComponentUrl('documents', entityIdDetails.entityId);
        this.gwtEmailsUrl = this.getComponentUrl('email', entityIdDetails.entityId);
        this.gwtResearchUrl = this.getComponentUrl('research', entityIdDetails.entityId);
        this.gwtMonitoringUrl = this.getComponentUrl('monitoring', entityIdDetails.entityId);
        this.gwtTransactionProfileUrl = this.getComponentUrl('transactions', entityIdDetails.entityId);
        this.gwtTimeTrackingUrl = this.getComponentUrl('time', entityIdDetails.entityId);
        this.gwtSurveyhUrl = this.getComponentUrl('surveys', entityIdDetails.entityId);
        this.gwtRelationShipDiagramUrl = this.getComponentUrl('structure', entityIdDetails.entityId);
      });
  }

  getComponentUrl(endpoint, entityId) {
    const baseUrl = ConstantsService.APP_HOME_URL;
    return this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}#!/${endpoint};id=${entityId}`);
  }

  onIframeLoad() {
    this.resizeIframe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resizeIframe();
  }

  resizeIframe() {
    const windowHeight = window.innerHeight;

    // uncomment for tabs support
    // this.iFrame.nativeElement.height = windowHeight - (this.isPerson ? 460 : 410);
    if (this.iFrame) {
      this.iFrame.nativeElement.height = windowHeight - (this.isPerson ? 400 : 350);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/other/entity-other.component.ts